import { useState } from 'react';
import { useGetItemSyncFailedItems } from '@/features/settings/work-integrations/queries/useGetItemSyncFailedItems';
import { SYNC_FAILURES_PAGE_SIZE, SyncFailuresTable } from './SyncFailuresTable';

type Props = {
  itemId: number;
};

export function ItemSyncFailures({ itemId }: Props) {
  const [page, setPage] = useState(0);
  const queryResult = useGetItemSyncFailedItems({
    itemIdOrSourceItemKey: String(itemId),
    page,
    pageSize: SYNC_FAILURES_PAGE_SIZE,
  });

  return (
    <SyncFailuresTable
      queryResult={queryResult}
      page={page}
      onPageChange={setPage}
      variant="item"
      tableTestId="item-sync-failures-list"
    />
  );
}
